import React from "react";

// Redux
import {useSelector, useDispatch} from "react-redux";
import {createEventCategory} from "../../../redux/features/events/categoriesSlice";

// Routing
import {useHistory} from "react-router-dom";

// Components
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "../../UI/MainPaper";
import EventCategoriesForm from "./EventCategoriesForm";
import Breadcrumbs from "../../Navigation/Breadcrumbs";

const EventCategoriesNew = () => {
  // Redux
  const dispatch = useDispatch();
  const {isLoading} = useSelector(state => state.eventCategories);

  // Routing
  const history = useHistory();

  const breadcrumbNameMap = {
    "/events": "Events",
    "/events/categories": "Event Categories",
    "/events/categories/new": "New Event Category",
  };

  const onCancel = () => {
    history.push("/events/categories");
  };
  const onSubmit = async values => {
    const eventCategoryObj = {
      category_id: null,
      ...values,
    };

    const res = await dispatch(createEventCategory(eventCategoryObj));
    // If event was created successfully redirect to events page and show user
    if (!res.error) {
      history.push({
        pathname: "/events/categories",
        state: {
          showSuccess: true,
          snackbarContent: `Your Event Category '${eventCategoryObj.name}' was successfully created!`,
          snackbarLink: `/events/categories/${res.id}`,
        },
      });
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <Typography component="h1" variant="h5" gutterBottom>
            New Event Category
          </Typography>
          <EventCategoriesForm
            onSubmit={onSubmit}
            onCancel={onCancel}
            isLoading={isLoading}
            submitButtonLabel="Create Event Category"
          />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default EventCategoriesNew;
